module.exports = __webpack_public_path__ + "static/media/icn_free.73ddf616.svg";